import { authPaths } from '@noah-labs/shared-constants';

export const authRoutes = {
  ...authPaths,
  newPasswordComplete: { path: '/auth/new-password/complete', title: 'Success' },
  // newPasswordEntry is use in be-core, be sure to update there if changing the path
  // can search for `authRoutes.newPasswordEntry` in be-core
  newPasswordEntry: { path: '/auth/new-password', title: 'Choose a new password' },
};
